// extracted by mini-css-extract-plugin
export default {"horizontal-scroll":"AdminPanel_horizontal-scroll__qpLql","table-container":"AdminPanel_table-container__9CLXz"};